import { injectable } from 'inversify';
import { Component } from '../../../concepts/objects';
import { ParticipantManager } from '../../canvas/participants/ParticipantManager';
import { resolve } from '../../Container';
import { DefineDateColumn } from '../dataExport/addons/DateDimension';
import { DefineParticipantColumn } from '../dataExport/addons/ParticipantDimension';
import { DefineSimpleDimension } from '../dataExport/addons/SimpleDimension';
import { FromFirstMatchExportAdapter } from '../dataExport/ExportAdapter';
import { IndexCard } from './IndexCard';

@injectable()
export class IndexCardExports extends FromFirstMatchExportAdapter {

    @resolve(ParticipantManager) private participants!: ParticipantManager;

    protected selector = (c: Component) => c.is(IndexCard);

    public readonly id = 'IndexCardExports';
    public readonly label = 'Index Cards';
    public readonly priority = 10;
    public readonly defaults = true;
    public readonly columns = [
        DefineSimpleDimension(
            IndexCard,
            'Title',
            'Adds a column that contains the title of each Index Card.',
            x => x.title
        ),
        DefineSimpleDimension(
            IndexCard,
            'Body',
            'Adds a column that contains the body of each Index Card.',
            x => x.content
        ),
        DefineParticipantColumn(
            IndexCard,
            'Author',
            'Adds a column that contains the creator of each Index Card.  You can choose use name, email or both in the output.',
            x => this.participants.get(x.userId)
        ),
        DefineDateColumn(
            IndexCard,
            'Created',
            'Adds a column that contains the date and time each Index Card was created.  Several date formatting options are available.',
            'shortDateTime',
            x => x.created
        ),
    ];
}


